import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  currencySignSelector,
  formatPrice,
  NO_VALUE_DISPLAY,
} from "@ryde/shared";

import { IRideSoftValidationErrorItemProps } from "../models";

export const RideSoftValidationErrorPriceRateChanged: FC<
  IRideSoftValidationErrorItemProps
> = ({ error }) => {
  const { t } = useTranslation();
  const currencySign = useRecoilValue(currencySignSelector);

  const message = `${t("ride.RIDE_SOFT_VALIDATION_ERROR_PRICE_CHANGED")}`;
  const willBe = `${t("ride.RIDE_SOFT_VALIDATION_WILL_BE")}`;
  const was = `${t("ride.RIDE_SOFT_VALIDATION_WAS")}`;
  const isLost = Number(error.additional?.diffPrice) < 0;
  const savedLost = !isLost
    ? t("ride.RIDE_SOFT_VALIDATION_SAVED")
    : t("ride.RIDE_SOFT_VALIDATION_DIFFERENCE");
  const minusResolved = isLost ? "-" : "";
  const diffPriceResolved = Number(error.additional?.diffPrice ?? 0);

  return (
    <li>
      {message} (<b>{willBe}:</b> {currencySign}
      {String(error.additional?.newPrice ?? NO_VALUE_DISPLAY)} | <b>{was}: </b>
      {currencySign}
      {formatPrice({
        value: Number(error.additional?.oldTargetRidePrice ?? 0),
      })}{" "}
      | <b>{savedLost}: </b>
      {currencySign}
      <span dir="ltr">
        {minusResolved}
        {formatPrice({
          value: isLost ? -1 * diffPriceResolved : diffPriceResolved,
        })}
      </span>
    </li>
  );
};
